module.exports = __webpack_public_path__ + "images/a5381f39bf863f1bcf12a2404d574613-brkfst.png";